module.exports = __webpack_public_path__ + "assets/img/11_479.b8324f69.jpg";